import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { GeoIPApi } from './sdk';
import { of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IpService {
  constructor(private geoIPApi: GeoIPApi, private http: HttpClient) {}

  locate(ip: string): Observable<any> {
    return this.geoIPApi.locate(ip);
  }

  getIP(): Observable<string> {
    return this.http.get('https://api.ipify.org/?format=json').pipe(
      catchError(() => of({ ip: '' })),
      map((res: { ip: string }) => res.ip),
    );
  }
}
